import React from 'react';
import { connect } from 'react-redux';

const Logo = props => {
  const {source} = props;

  return(
    <div>
      <img src={source}  alt="logo" height={28} width="auto" />
      <div style={styles.version}>v. {process.env.REACT_APP_VERSION} / a. {props.backendVersion}</div>
    </div>
  )
}

const mapStateToProps = state => {
  const { backendVersion } = state.data;
  return {
    backendVersion
  }
}

export default connect(mapStateToProps)(Logo);

const styles = {
  version: { 
    fontSize: 8, 
    paddingLeft: 40,
  },
}